import { useMemo } from 'react'
import { atomWithGlobalStore } from '@highlight/ipc/jotai'
import { useAtom } from 'jotai'

const audioFeaturesEnabledAtom = atomWithGlobalStore<boolean>('settings', 'audio-features-enabled', true)

export const useAudioFeaturesPermission = () => {
  const [areAudioFeaturesEnabled, setAreAudioFeaturesEnabled] = useAtom(audioFeaturesEnabledAtom)

  return useMemo(() => {
    return {
      areAudioFeaturesEnabled,
      setAreAudioFeaturesEnabled,
    }
  }, [areAudioFeaturesEnabled, setAreAudioFeaturesEnabled])
}
